var TPL = {
	templates:{},
	langs:{},
	defaults:{},

	init: function(skin, postfunc) {
		Handlebars.registerHelper('lng', function(symbol, def) {
			return new Handlebars.SafeString(TPL.lng(symbol, def));
		});

		if (skin != undefined && skin != "") {
			TPL.skinName = skin;
			$("body").append("<div id='skin-container'></div>");
			$.getJSON("skins/" + skin + "/config.json", function(result) {
				TPL.skin = result;

				for(var r in TPL.skin.templates) {
					var s = TPL.skin.templates[r];
					var dd = $("<div></div>");
					$("#skin-container").append(dd);
					dd.load("skins/" + skin + "/" + TPL.skin.templates[r] + "?" + Date.now());
				}


				for(var r in TPL.skin.styles) {
					var fileref = document.createElement("link");
					fileref.rel = "stylesheet";
					fileref.type = "text/css";
					fileref.href = "skins/" + skin + "/" + TPL.skin.styles[r] + "?" + Date.now();
					document.getElementsByTagName("head")[0].appendChild(fileref)
				}

				postfunc();
			});
		} else postfunc();
	},

	lng: function(symbol, def) {
		var s = Handlebars.escapeExpression(symbol),
   		d = Handlebars.escapeExpression(def);

   		if (def != undefined && def != "") TPL.defaults[symbol] = def;
   		else if ((def == undefined || def == "") && TPL.defaults[symbol] != undefined) def = TPL.defaults[symbol];

   		if (TPL.langs.hasOwnProperty(s))
			return TPL.langs[s];
		else 
  			return def;
	},

	render: function(name, params) {
		if (TPL.skinName != undefined && TPL.skin != undefined && TPL.skin.skinned != undefined) {
			if (TPL.skin.skinned[name] != undefined) name = TPL.skin.skinned[name];
		}

		if (TPL.templates[name] == undefined) {
			var source   = $("#" + name).html();
			var template = Handlebars.compile(source);
			TPL.templates[name] = template;
		}
		
		var tt = TPL.templates[name];
		return tt(params);
	},
	
	loadTemplate: function(name, path) {
		var source;
		var template;

		$.ajax({
			url: path,
			cache: true,
			success: function(data) {
				source    = data;
				template  = Handlebars.compile(source);
				TPL.templates[name] = template;
			}               
		});         
	}	
	
}